import CountDown from '@/components/CountDown';
import PageLayout from '@/components/PageLayout';
import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Form } from 'antd';
import css from './index.module.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';
export default function ResetSuccess({ lang, SEO }: any) {
    const { useRouter, useLang } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('shared');
    const goLogin = () => {
        signupCookie({
            entry_name: lang.site_register_got_it,
        });
        router.push({ pathname: `/${locale}/login` });
    };

    return (
        <PageLayout style={{ background: '#f8f8f8' }}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <div className={`${css.validate}`}>
                {/* {lang.title} */}
                <div className="validate-wrap">
                    <div className="validate-box">
                        <div className="sendEmail">
                            <div className="icon-wrapper">
                                <Image src="/icons/register-success.svg" alt={lang.site_login_forgot_password_successfully_changed} width={72} height={72} />
                            </div>
                            <p>{lang.site_login_forgot_password_successfully_changed}</p>
                            <Form name="normal_validate" className="validate-form" initialValues={{ remember: true }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        className="black-btn large validate-form-button"
                                        onClick={goLogin}
                                        aria-label={lang.site_register_got_it}
                                    >
                                        {lang.site_register_got_it}
                                        <CountDown sec={3} onFinish={goLogin} />
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
